// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/chat/v1/dialogs.proto (package gdx.gateway.web.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Enumerate possible reason.
 *
 * @generated from enum gdx.gateway.web.chat.v1.RestrictionReason
 */
export enum RestrictionReason {
  /**
   * @generated from enum value: RESTRICTION_REASON_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: RESTRICTION_REASON_DAILY_MESSAGES_LIMIT = 1;
   */
  DAILY_MESSAGES_LIMIT = 1,

  /**
   * @generated from enum value: RESTRICTION_REASON_DAILY_DIALOGS_LIMIT = 2;
   */
  DAILY_DIALOGS_LIMIT = 2,

  /**
   * @generated from enum value: RESTRICTION_REASON_MAX_MESSAGE_LENGTH = 3;
   */
  MAX_MESSAGE_LENGTH = 3,

  /**
   * @generated from enum value: RESTRICTION_REASON_NOT_ENOUGH_CREDITS = 4;
   */
  NOT_ENOUGH_CREDITS = 4,

  /**
   * @generated from enum value: RESTRICTION_REASON_NO_ACTIVE_DIALOG = 5;
   */
  NO_ACTIVE_DIALOG = 5,

  /**
   * @generated from enum value: RESTRICTION_REASON_AUTOCHARGE_FAILED = 6;
   */
  AUTOCHARGE_FAILED = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(RestrictionReason)
proto3.util.setEnumType(RestrictionReason, "gdx.gateway.web.chat.v1.RestrictionReason", [
  { no: 0, name: "RESTRICTION_REASON_INVALID" },
  { no: 1, name: "RESTRICTION_REASON_DAILY_MESSAGES_LIMIT" },
  { no: 2, name: "RESTRICTION_REASON_DAILY_DIALOGS_LIMIT" },
  { no: 3, name: "RESTRICTION_REASON_MAX_MESSAGE_LENGTH" },
  { no: 4, name: "RESTRICTION_REASON_NOT_ENOUGH_CREDITS" },
  { no: 5, name: "RESTRICTION_REASON_NO_ACTIVE_DIALOG" },
  { no: 6, name: "RESTRICTION_REASON_AUTOCHARGE_FAILED" },
]);

/**
 * Concrete dialog message structure.
 *
 * @generated from message gdx.gateway.web.chat.v1.DialogMessage
 */
export class DialogMessage extends Message<DialogMessage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: bool is_new = 2;
   */
  isNew = false;

  /**
   * @generated from field: gdx.gateway.web.chat.v1.DialogMessageContent content = 3;
   */
  content?: DialogMessageContent;

  /**
   * @generated from field: string from_user_id = 4;
   */
  fromUserId = "";

  /**
   * @generated from field: google.protobuf.Duration created_duration = 5;
   */
  createdDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 6;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string message_position = 7;
   */
  messagePosition = "";

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem = false;

  /**
   * @generated from field: bool is_suspicious_content = 9;
   */
  isSuspiciousContent = false;

  constructor(data?: PartialMessage<DialogMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.DialogMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "content", kind: "message", T: DialogMessageContent },
    { no: 4, name: "from_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_duration", kind: "message", T: Duration },
    { no: 6, name: "created_time", kind: "message", T: Timestamp },
    { no: 7, name: "message_position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "is_system", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_suspicious_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessage {
    return new DialogMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessage {
    return new DialogMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessage {
    return new DialogMessage().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessage | PlainMessage<DialogMessage> | undefined, b: DialogMessage | PlainMessage<DialogMessage> | undefined): boolean {
    return proto3.util.equals(DialogMessage, a, b);
  }
}

/**
 * Possible variants of dialogs content.
 *
 * @generated from message gdx.gateway.web.chat.v1.DialogMessageContent
 */
export class DialogMessageContent extends Message<DialogMessageContent> {
  /**
   * @generated from oneof gdx.gateway.web.chat.v1.DialogMessageContent.content
   */
  content: {
    /**
     * @generated from field: string text = 2;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.DialogMessageImage image = 3;
     */
    value: DialogMessageImage;
    case: "image";
  } | {
    /**
     * @generated from field: gdx.gateway.web.chat.v1.DialogMessageGift gift = 4;
     */
    value: DialogMessageGift;
    case: "gift";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DialogMessageContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.DialogMessageContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "content" },
    { no: 3, name: "image", kind: "message", T: DialogMessageImage, oneof: "content" },
    { no: 4, name: "gift", kind: "message", T: DialogMessageGift, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageContent | PlainMessage<DialogMessageContent> | undefined, b: DialogMessageContent | PlainMessage<DialogMessageContent> | undefined): boolean {
    return proto3.util.equals(DialogMessageContent, a, b);
  }
}

/**
 * Dialog message with image content.
 *
 * @generated from message gdx.gateway.web.chat.v1.DialogMessageImage
 */
export class DialogMessageImage extends Message<DialogMessageImage> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<DialogMessageImage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.DialogMessageImage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageImage {
    return new DialogMessageImage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageImage {
    return new DialogMessageImage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageImage {
    return new DialogMessageImage().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageImage | PlainMessage<DialogMessageImage> | undefined, b: DialogMessageImage | PlainMessage<DialogMessageImage> | undefined): boolean {
    return proto3.util.equals(DialogMessageImage, a, b);
  }
}

/**
 * Dialog message with gift content.
 *
 * @generated from message gdx.gateway.web.chat.v1.DialogMessageGift
 */
export class DialogMessageGift extends Message<DialogMessageGift> {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId = "";

  /**
   * @generated from field: string photo_id = 2;
   */
  photoId = "";

  /**
   * @generated from field: string text = 3;
   */
  text = "";

  constructor(data?: PartialMessage<DialogMessageGift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.DialogMessageGift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageGift {
    return new DialogMessageGift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageGift {
    return new DialogMessageGift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageGift {
    return new DialogMessageGift().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageGift | PlainMessage<DialogMessageGift> | undefined, b: DialogMessageGift | PlainMessage<DialogMessageGift> | undefined): boolean {
    return proto3.util.equals(DialogMessageGift, a, b);
  }
}

/**
 * Describes dialog gift which you can get from server.
 *
 * @generated from message gdx.gateway.web.chat.v1.DialogGift
 */
export class DialogGift extends Message<DialogGift> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: uint32 price_credits = 2;
   */
  priceCredits = 0;

  /**
   * @generated from field: string photo_id = 3;
   */
  photoId = "";

  /**
   * @generated from field: bool is_free = 4;
   */
  isFree = false;

  /**
   * @generated from field: google.protobuf.Duration available_in_duration = 5;
   */
  availableInDuration?: Duration;

  /**
   * premium, basic
   *
   * @generated from field: string category_id = 6;
   */
  categoryId = "";

  /**
   * love_and_sweet, ice_breakers
   *
   * @generated from field: string subcategory_id = 7;
   */
  subcategoryId = "";

  constructor(data?: PartialMessage<DialogGift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.chat.v1.DialogGift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_credits", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_free", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "available_in_duration", kind: "message", T: Duration },
    { no: 6, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "subcategory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogGift {
    return new DialogGift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogGift {
    return new DialogGift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogGift {
    return new DialogGift().fromJsonString(jsonString, options);
  }

  static equals(a: DialogGift | PlainMessage<DialogGift> | undefined, b: DialogGift | PlainMessage<DialogGift> | undefined): boolean {
    return proto3.util.equals(DialogGift, a, b);
  }
}

